module.exports = __webpack_public_path__ + "img/share-buttom.1a0d0662.svg";